import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { DatePrice } from "@slfinrtl/ui-bff-routes"
import { CheckboxField, FormLayout, InputField } from "src/components/form"
import { GridItem } from "src/components/grid/GridItem"
import { gridSize } from "../../../common/gridSize.const"
import { PricingFormGrid } from "../../components/PricingFormGrid"
import { PriceHistory } from "../../components/priceHistory/PriceHistory"
import type { AustraliaNetPricePricingFields } from "../australiaNetPricePricing.fields"

export interface AustraliaNetPricePricingFormProps {
	fields: AustraliaNetPricePricingFields
	priceHistory: DatePrice[] | undefined
}

export const AustraliaNetPricePricingForm = ({ fields, priceHistory }: AustraliaNetPricePricingFormProps) => {
	return (
		<PricingFormGrid>
			<GridItemFormLayout size={gridSize}>
				<InputField {...fields.price} />
				<VatDeductibleCheckboxField {...fields.vatDeductible} />
				<InputField {...fields.minimumPrice} />
				<InputField {...fields.purchasePrice} />
				<InputField {...fields.netPrice} />
			</GridItemFormLayout>

			{priceHistory && priceHistory.length > 0 && (
				<GridItem size={gridSize}>
					<PriceHistory view={priceHistory} />
				</GridItem>
			)}
		</PricingFormGrid>
	)
}

const StyledFormLayout = styled(FormLayout)`
	align-self: start; /* needed when price history is larger than form, otherwise gaps between inputs increase */
`

const GridItemFormLayout = StyledFormLayout.withComponent(GridItem)

const VatDeductibleCheckboxField = styled(CheckboxField)`
	margin-bottom: ${spacingStaticMd};
`
